// extracted by mini-css-extract-plugin
export default {"changePassword":"styles_changePassword__IW52K"};